navigator.sayswho= (function(){
	var ua= navigator.userAgent, tem,
		M= ua.match(/(opera|chrome|crios|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [],
		mobile = /Android.+Mobile|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);
	if(/trident/i.test(M[1])){
		tem=  /\brv[ :]+(\d+)/g.exec(ua) || [];
		return {
			'browser': 'IE',
			'version': tem[1] || '',
			'mobile': mobile,
		};
	}
	if(M[1]=== 'Chrome'){
		tem= ua.match(/\b(OPR|Edge)\/(\d+)/);
		if(tem!= null) return {
			'browser': tem[1].replace('OPR', 'Opera'),
			'version': tem[2] || '',
			'mobile': mobile,
		}
	}
	M= M[2]? [M[1], M[2]]: [navigator.appName, navigator.appVersion, '-?'];
	if((tem= ua.match(/version\/(\d+)/i))!= null) M.splice(1, 1, tem[1]);
	if(M[0]=== 'CriOS') M[0]= 'Chrome';
	return {
		'browser': M[0],
		'version': M[1],
		'mobile': mobile,
	};
})();
